import { useGetCommon, type RoomPreviewInfoResponse } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import { OtherRoomInfo } from "./components/otherRoomInfo";

export const OtherRoomPreView = () => {
    const { data } = useGetCommon<RoomPreviewInfoResponse>({ section: "rooms" });
    const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });

    return data ? (
        <Box ref={ref} position="relative" w="100%" h="100dvh" background="#333">
            <OtherRoomInfo currentRooms={data.currentRooms} inView={inView} />
        </Box>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
